module.exports = __webpack_public_path__ + "img/icon-05-subscriptionAsset 10.7ad8074e.svg";